module.exports = __webpack_public_path__ + "static/img/footer-menu-icon05-1.9b9099cf.svg";